module.exports = __webpack_public_path__ + "static/media/tick icon.7ae89b37.png";